export const Locale = {
  ENGLISH_CANADA: 'en-CA',
  ENGLISH_US: 'en-US'
};
